[
  {
    "code": "QA-DA",
    "name": "Ad Dawhah"
  },
  {
    "code": "QA-GH",
    "name": "Al Ghuwayriyah"
  },
  {
    "code": "QA-JU",
    "name": "Al Jumayliyah"
  },
  {
    "code": "QA-KH",
    "name": "Al Khawr"
  },
  {
    "code": "QA-WA",
    "name": "Al Wakrah"
  },
  {
    "code": "QA-RA",
    "name": "Ar Rayyan"
  },
  {
    "code": "QA-JB",
    "name": "Jariyan al Batnah"
  },
  {
    "code": "QA-MS",
    "name": "Madinat ash Shamal"
  },
  {
    "code": "QA-US",
    "name": "Umm Salal"
  }
]